<template>
  <div ref="div" @confirmation="confirmationReceived" @notification="messageReceived">
    <b-alert v-if="show" show :variant="variant" :dismissible="!confirming" @dismiss="clearMessage">
      {{message}}
      <span class="buttons" v-if="confirming">
        <b-button size="sm" variant="success" @click="onConfirm">Ok</b-button>
        <b-button size="sm" variant="primary" @click="onCancel">Cancel</b-button>
      </span>
    </b-alert>
    <slot/>
  </div>
</template>
<style lang="scss" scoped>
.buttons {
  float: right;
  .btn {
    padding: 4px 12px;
    height: 30px;
  }
}
</style>
<script>
export default {
  data() {
    return {
      message: '',
      type: '',
      confirming: false,
      confirm: null
    }
  },
  mounted() {
    console.log(this.$refs.div);
    this.$refs.div.addEventListener('notification', event => console.log('wtf', event));
  },
  computed: {
    show() {
      return !!this.variant;
    },
    variant() {
      // Only show success and error types
      return {success: 'success', error: 'danger', confirm: 'warning'}[this.type];
    }
  },
  methods: {
    messageReceived(event) {
      console.log('messageReceived', event);
      let {message, type} = event.detail;
      this.message = message;
      this.type = type;
      this.confirming = false;
    },
    clearMessage() {
      this.message = '';
      this.type = '';
      this.confirming = false;
    },
    confirmationReceived(event) {
      event.preventDefault();
      this.confirming = true;
      this.type = 'confirm';
      this.message = event.detail.message;
      this.confirm = event.detail.confirm;
      console.log('confirmationReceived!')
    },
    onConfirm() {
      this.clearMessage();
      this.confirm(true);
    },
    onCancel() {
      this.clearMessage();
      this.confirm(false);
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/MessageAlert.vue